import { ProgressIndicator } from '../../components/ProgressIndicator';
import { useGetApplicationSubmissionStatus, useScrollToTop } from '../../hooks';
import { MAX_SYNC_STATUS_WAIT } from '../../utils';
import NextSteps from './NextSteps';
import { ApplicationSubmissionStatus } from './types';

function ApplicationStatus() {
  useScrollToTop();
  const { status, time } = useGetApplicationSubmissionStatus();

  if (status === ApplicationSubmissionStatus.FETCHING) {
    return <ProgressIndicator time={time ?? 0} max={MAX_SYNC_STATUS_WAIT} />;
  }

  return <NextSteps status={status} />;
}

export default ApplicationStatus;
